// extracted by css-extract-rspack-plugin
export default {"card":"card-RllXnR","divider1":"divider1-lsl8XM","divider2":"divider2-vhmp11","zoomText":"zoomText-HBNFSr"};